import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useAdminDeleteUser = () => {
  const queryClient = useQueryClient();

  return apiClient.admin.deleteUser.useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-users-list'] });
      toast.success('User deleted successfully');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Failed to delete user');
    },
  });
};
